import { render, staticRenderFns } from "./DataSourceList.vue?vue&type=template&id=77b958f2&scoped=true&"
import script from "./DataSourceList.vue?vue&type=script&lang=js&"
export * from "./DataSourceList.vue?vue&type=script&lang=js&"
import style0 from "./DataSourceList.vue?vue&type=style&index=0&id=77b958f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b958f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77b958f2')) {
      api.createRecord('77b958f2', component.options)
    } else {
      api.reload('77b958f2', component.options)
    }
    module.hot.accept("./DataSourceList.vue?vue&type=template&id=77b958f2&scoped=true&", function () {
      api.rerender('77b958f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/datasource/DataSourceList.vue"
export default component.exports